import { render, staticRenderFns } from "./AcceptedHistory.vue?vue&type=template&id=772d4acc&scoped=true&"
import script from "./AcceptedHistory.vue?vue&type=script&lang=js&"
export * from "./AcceptedHistory.vue?vue&type=script&lang=js&"
import style0 from "./AcceptedHistory.vue?vue&type=style&index=0&id=772d4acc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772d4acc",
  null
  
)

export default component.exports